<template>
  <div class="container" id="company">
    <div class="header py-5 w-100 col-12 col-md-12">
      <div class="row">
        <div class="col-12 py-3">
          <a
            class="back-button-company"
            href="javascript:history.go(-1)"
            v-if="!origin"
          >
            <img
              src="/images/arrow_back_blue.svg"
              alt
              style="margin: 0 4px 4px 0"
            />
            Back
          </a>
          <a
            class="back-button-company"
            href="javascript:void(0)"
            v-else
            @click="backToHome"
          >
            <img
              src="/images/arrow_back_blue.svg"
              alt
              style="margin: 0 4px 4px 0"
            />
            Back
          </a>
        </div>
        <div class="col-12">
          <div style="width: 100%" class="company-detail">
            <div class="d-flex flex-md-row flex-column mb-5 align-items-center">
              <div class="mr-3">
                <div style="padding: 8px">
                  <img
                    v-if="company.logo_src || companyModel.logo_src"
                    v-bind:src="
                      company.logo_src
                        ? company.logo_src
                        : companyModel.logo_src
                    "
                    alt="Company Logo"
                    style="max-height: 93px"
                  />
                </div>
              </div>
              <div class="company-header">
                <span class="company-header__title">
                  {{ company.name ? company.name : companyModel.name }}
                </span>
                <br />
                <div style="display: inline-block" v-if="parseInt(rating) > 70">
                  <div
                    class="green-rating"
                    v-for="i in Math.floor(parseInt(rating) / 10)"
                    :key="`green-${i}`"
                  ></div>
                  <div
                    class="null-rating"
                    v-for="i in 10 - Math.floor(parseInt(rating) / 10)"
                    :key="`null-green-${i}`"
                  ></div>
                </div>
                <div
                  style="display: inline-block"
                  v-else-if="parseInt(rating) > 30"
                >
                  <div
                    class="yellow-rating"
                    v-for="i in Math.floor(parseInt(rating) / 10)"
                    :key="`yellow-${i}`"
                  ></div>
                  <div
                    class="null-rating"
                    v-for="i in 10 - Math.floor(parseInt(rating) / 10)"
                    :key="`null-yellow-${i}`"
                  ></div>
                </div>
                <div
                  style="display: inline-block"
                  v-else-if="parseInt(rating) <= 30"
                >
                  <div
                    class="red-rating"
                    v-for="i in Math.floor(parseInt(rating) / 10)"
                    :key="`red-${i}`"
                  ></div>
                  <div
                    class="null-rating"
                    v-for="i in 10 - Math.floor(parseInt(rating) / 10)"
                    :key="`null-red-${i}`"
                  ></div>
                </div>
                <div
                  style="display: inline-block"
                  v-else-if="!parseInt(rating)"
                >
                  <div
                    class="null-rating"
                    v-for="i in 10"
                    :key="`null-${i}`"
                  ></div>
                </div>
                <br />
                <span class="company-header__remote"
                  >{{ rating }} Remote friendly</span
                >
              </div>
              <div class="btn-wrapper d-md-block d-flex">
                <button
                  class="btn btn-follow"
                  v-bind:class="{
                    'btn-follow__following': !is_following,
                    'btn-follow__unfollow': is_following,
                  }"
                  @click="toggleFollow"
                >
                  {{ !is_following ? "Follow" : "Unfollow" }}
                </button>
              </div>
            </div>

            <div class="company-description mb-5">
              <div class="row">
                <div class="col-12 col-md">
                  <span class="company-description__title">Location</span>
                  <p>
                    {{ company.city ? company.city : companyModel.city }},
                    {{
                      company.country ? company.country : companyModel.country
                    }}
                  </p>
                </div>
                <div class="col-12 col-md">
                  <span class="company-description__title">WFH Status</span>
                  <p v-text="getWorkFromHome()"></p>
                </div>
                <div class="col-12 col-md">
                  <span class="company-description__title">Travel</span>
                  <p v-text="getTravel()"></p>
                </div>
                <div class="col-12 col-md">
                  <span class="company-description__title">Visitors</span>
                  <p v-text="getVisitors()"></p>
                </div>
                <div class="col-12 col-md">
                  <span class="company-description__title">Events</span>
                  <p v-text="getEvents()"></p>
                </div>
              </div>
            </div>

            <div class="summary mb-4">
              <div class="summary__title mb-2">Precautionary Measures</div>

              <div class="summary__list" v-text="getWorkFromHomeText()"></div>
              <div class="summary__list" v-text="getTravelText()"></div>
              <div class="summary__list" v-text="getVisitorsText()"></div>
              <div class="summary__list" v-text="getEventsText()"></div>
            </div>

            <div class="summary mb-4">
              <div class="summary__title mb-2">Other Measures</div>
              <div
                class="summary__list"
                v-text="company.other_remarks || 'N/A'"
              ></div>
            </div>

            <div class="summary mb-4">
              <div class="summary__title mb-2">General</div>

              <div
                class="summary__list"
                v-text="getVideoConferenceText()"
              ></div>
              <div
                class="summary__list"
                v-text="getProjectManagementText()"
              ></div>
              <div class="summary__list" v-text="getClearSOPText()"></div>
              <div
                class="summary__list"
                v-text="getCommunicationsProtocolText()"
              ></div>
            </div>

            <div
              class="summary mb-4"
              v-if="
                remote_measures.has_tech_team ||
                remoteMeasuresModel.has_tech_team
              "
            >
              <div class="summary__title mb-2">Tech Team</div>

              <div class="summary__list" v-text="getGitUsageText()"></div>
              <div
                class="summary__list"
                v-text="getScheduledScrumMeetingsText()"
              ></div>
            </div>

            <div class="remote-readiness">
              Remote Readiness Rating:
              <span v-text="rating"></span>
            </div>

            <!-- <div class="summary mt-5">
      Offices and timezones
      <br />
      <div v-if="typeof company !== 'string'" class="summary">
        <p v-for="office in company.offices" class="my-2" :key="office.id">
          <i class="fas fa-map-marker-alt mr-2"></i>
          {{office.text}}
          <b>
            {{office.is_default ? '(Default)':
            ''}}
          </b>
        </p>
      </div>
      <div v-else class="summary">
        <p v-for="office in companyModel.offices" class="my-2" :key="office.id">
          <i class="fas fa-map-marker-alt mr-2"></i>
          {{office.text}}
          <b>
            {{office.is_default ? '(Default)':
            ''}}
          </b>
        </p>
      </div>
      <p v-if="company.offices && company.offices.length === 0">No offices available.</p>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import remoteReadinessRating from "./RemoteReadinessRating";
import DropDownOptions from "./DropdownOptionsConfig";
import Options from "./TextOptionsConfig";

export default {
  props: ["company", "remote_measures", "is_following", "origin"],

  data() {
    return {
      companyModel: {},
      remoteMeasuresModel: {},
    };
  },

  computed: {
    rating() {
      const displayableRemoteMeasures =
        Object.keys(this.remoteMeasuresModel).length !== 0
          ? {
              clear_sop: this.remoteMeasuresModel.has_clear_sops == 1,
              help_remote_ready:
                this.remoteMeasuresModel.needs_help_remote_ready == 1,
              project_management:
                this.remoteMeasuresModel.uses_project_management_tools == 1,
              schedule_regular_scrums:
                this.remoteMeasuresModel.schedule_regular_scrums == 1,
              set_communications_protocol:
                this.remoteMeasuresModel.set_communications_protocol == 1,
              uses_git: this.remoteMeasuresModel.uses_git == 1,
              video_conference:
                this.remoteMeasuresModel.uses_video_conference_tools == 1,
              has_tech_team: this.remoteMeasuresModel.has_tech_team == 1,
            }
          : this.remote_measures;

      return remoteReadinessRating(displayableRemoteMeasures) + "%";
    },
  },

  methods: {
    getWorkFromHome() {
      if (Object.keys(this.companyModel).length !== 0) {
        return this.companyModel.allow_work_from_home;
      }

      return DropDownOptions["wfhOptions"][this.company.work_from_home];
    },

    getWorkFromHomeText() {
      if (Object.keys(this.companyModel).length !== 0) {
        return Options["workFromHomeText"][
          _.invert(DropDownOptions["wfhOptions"])[
            this.companyModel.allow_work_from_home
          ]
        ];
      }

      return Options["workFromHomeText"][this.company.work_from_home];
    },

    getTravel() {
      if (Object.keys(this.companyModel).length !== 0) {
        return this.companyModel.allow_travel;
      }

      return DropDownOptions["travelOptions"][this.company.travel];
    },

    getTravelText() {
      if (Object.keys(this.companyModel).length !== 0) {
        return Options["travelText"][
          _.invert(DropDownOptions["travelOptions"])[
            this.companyModel.allow_travel
          ]
        ];
      }

      return Options["travelText"][this.company.travel];
    },

    getVisitors() {
      if (Object.keys(this.companyModel).length !== 0) {
        return this.companyModel.allow_visitors;
      }

      return DropDownOptions["visitorOptions"][this.company.visitors];
    },

    getVisitorsText() {
      if (Object.keys(this.companyModel).length !== 0) {
        return Options["travelText"][
          _.invert(DropDownOptions["visitorOptions"])[
            this.companyModel.allow_visitors
          ]
        ];
      }

      return Options["visitorsText"][this.company.visitors];
    },

    getEvents() {
      if (Object.keys(this.companyModel).length !== 0) {
        return this.companyModel.allow_events;
      }

      return DropDownOptions["eventsOptions"][this.company.events];
    },

    getEventsText() {
      if (Object.keys(this.companyModel).length !== 0) {
        return Options["eventsText"][
          _.invert(DropDownOptions["eventsOptions"])[
            this.companyModel.allow_events
          ]
        ];
      }

      return Options["eventsText"][this.company.events];
    },

    getGitUsageText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["usesGitText"][!!+this.remoteMeasuresModel.uses_git];
      }

      return Options["usesGitText"][this.remote_measures.uses_git];
    },

    getVideoConferenceText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["videoConferenceText"][
          !!+this.remoteMeasuresModel.uses_video_conference_tools
        ];
      }

      return Options["videoConferenceText"][
        this.remote_measures.video_conference
      ];
    },

    getProjectManagementText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["projectManagementText"][
          !!+this.remoteMeasuresModel.uses_project_management_tools
        ];
      }

      return Options["projectManagementText"][
        this.remote_measures.project_management
      ];
    },

    getClearSOPText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["clearSOPText"][
          !!+this.remoteMeasuresModel.has_clear_sops
        ];
      }

      return Options["clearSOPText"][this.remote_measures.clear_sop];
    },

    getRemoteReadyHelpText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["helpRemoteReadyText"][
          !!+this.remoteMeasuresModel.needs_help_remote_ready
        ];
      }

      return Options["helpRemoteReadyText"][
        this.remote_measures.help_remote_ready
      ];
    },

    getCommunicationsProtocolText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["setCommsProtocolText"][
          !!+this.remoteMeasuresModel.set_communications_protocol
        ];
      }

      return Options["setCommsProtocolText"][
        this.remote_measures.set_communications_protocol
      ];
    },

    getScheduledScrumMeetingsText() {
      if (Object.keys(this.remoteMeasuresModel).length !== 0) {
        return Options["scheduleRegularScrumText"][
          !!+this.remoteMeasuresModel.schedule_regular_scrums
        ];
      }

      return Options["scheduleRegularScrumText"][
        this.remote_measures.schedule_regular_scrums
      ];
    },

    async toggleFollow() {
      try {
        await axios.post(
          `/company/${this.company.id ?? this.companyModel.id}/follow`
        );
        this.is_following = !this.is_following;
      } catch (e) {
        if (e.response.status === 401) {
          location.href = "/login";
        }
      }
    },

    backToHome() {
      this.$emit("backToHome");
    },
  },

  mounted() {
    if (typeof this.company === "string") {
      this.companyModel = JSON.parse(this.company);
    }

    if (typeof this.remote_measures === "string") {
      this.remoteMeasuresModel = JSON.parse(this.remote_measures);
    }
  },
};
</script>

<style scoped lang="scss">
.company-detail {
  .remote-readiness {
    color: #303030;
    font-family: Lato;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
  }
  .summary {
    &__title {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 22px;
    }

    &__list {
      color: #303030;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0;
      line-height: 28px;
    }
  }

  .btn-wrapper {
    margin: 0 0 0 auto;
    @media (max-width: 768px) {
      width: 100%;
      margin-top: 28px;
      /* margin: 0; */

      .btn-follow {
        width: 100%;
      }
    }
  }

  .company-header {
    color: #9696a8;
    font-family: Montserrat;
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;

    &__title {
      color: #222227;
      font-family: Lato;
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 60px;
    }

    &__remote {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
      line-height: 22px;
    }
  }

  .company-description {
    &__title {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
      line-height: 22px;
    }

    p {
      color: #303030;
      font-family: Lato;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 28px;
    }
  }

  .btn-wfh-primary {
    font-size: 14px;
    font-weight: 700;
    background-color: #5145ff;
    color: #fff;
    border-radius: 6px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  }

  .btn-follow {
    width: 160px;
    color: #ffffff;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border-radius: 4px;

    &__following {
      background-color: #000000;
      color: #ffffff;
    }

    &__unfollow {
      color: #28282e;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
      background-color: #ffffff;
      border: 1px solid #28282e;
    }
  }
}
</style>
